import { Component } from '@angular/core';
import { CommonService } from '@services/app.common.service';
import { AuthenticationService } from '@services/authentication.service';
import { first } from 'rxjs/operators';
import { StatusCode } from './_shared/_enums/Common';
import { JTUserIdleService } from './_shared/userIdle/user-idle.service';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  public refreshTokenFailedtimerCount = 0;
  public refreshTokenInProgress: boolean = false;
  public failedTokeninterval: any;
  public timerCount = 0;
  public refreshIntervalId: any;

  constructor(private common: CommonService, private router: Router,private authService: AuthenticationService, private userIdle: JTUserIdleService) {
     
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.common.RemoveLocalStorage("refreshTokenInProgress");
      }
      else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.common.RemoveLocalStorage("refreshTokenInProgress");
        setTimeout(() => {
          this.initCountDownTimer();
        }, 2000);
        
      }
    });
    var userLang = navigator.language.split('-')[0]; // use navigator lang if available
    userLang = /(fr|en)/gi.test(userLang) ? userLang : 'en';
    this.common.SetLocalStorage('lang', userLang);
  }

  ngOnInit() {
     
    this.refreshIntervalId = setInterval(() => {
      this.refreshToken();
    }, 60 * 1000);
  }

  public initCountDownTimer() {
    this.userIdle.stopWatching();
    var settings = this.common.getSettings();
    var clientSetting = settings.ClientSetting;
    var idleTimeOut = 2100;
    if (clientSetting != null && clientSetting != "") {
      idleTimeOut = clientSetting.IdleTimeOut;
    }
    this.userIdle.setConfigValues({ idle: idleTimeOut, timeout: 300, ping: 300 })
    console.log('Moduel Regstration done startWatching:');
    this.userIdle.startWatching();
   // this.modelShown = false;
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
      if (!this.common.isNullOrWhiteSpace(count)) {
        var remainingTime = 300 - count;
        this.timerCount = remainingTime;
        //if (this.timerCount <= 0) {
        // this.common.logOut();
        //}

        if (this.authService.isUserLoggedIn()) {
          //this.openConfirmModal();
        }
      }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.common.RedirectToLogin();
    });
    this.userIdle.ping$.subscribe(() => {
      //this.refreshToken()
    }
    );
  }
  refreshToken(forceRefresh = false, closeModal = false) {
     
    var $this = this;
    if (!this.authService.isUserLoggedIn())
      return;
    var currentDate = new Date();
    var lastRefreshTime = new Date(this.common.GetFromLocalStorage("lastTokenRefreshtime"));
    var difference = currentDate.getTime() - lastRefreshTime.getTime(); // This will give difference in milliseconds
    var resultInSeconds = Math.round(difference / 1000);
    //calculate remaining token time in seconds
    var tokenExpireDate = this.authService.GetTokenExpirationDate();
    var remainingTime = Math.round((tokenExpireDate.getTime() - currentDate.getTime()) / 1000);
    if (remainingTime <= 180) {
      if (this.refreshTokenFailedtimerCount == 0) {
        this.common.RemoveLocalStorage("refreshTokenInProgress");
        this.refreshTokenFailedtimerCount = remainingTime - 5;
        this.startRefreshTokenFailedTimer();
      }
      //this.refreshTokenFaildedModal.show();
    }
    var refreshTokenInProgressTime = new Date(this.common.GetFromLocalStorage("refreshTokenInProgress"))
    var remainingTime = Math.round((currentDate.getTime() - refreshTokenInProgressTime.getTime()) / 1000);
    if (remainingTime <= 10)
      return;
    
    if (resultInSeconds >= 300 || forceRefresh) {
      this.common.SetLocalStorage("refreshTokenInProgress", new Date());
      var lastToken = this.common.GetAccessToken();
      this.authService.refreshToken().pipe(first()).subscribe((res: any) => {
        this.refreshTokenInProgress = false;
        try {
          if (res.status == StatusCode.OK) {
            this.common.RemoveLocalStorage("refreshTokenInProgress");
            this.common.SetLocalStorage("lastTokenRefreshtime", new Date());
            this.common.SetAccessToken(res.resultData);
            if (closeModal) {
              //this.modelShown = false;
             // this.confirmLogoutModal.hide();
              this.userIdle.resetTimer();
            }
            //manual token refersh code
           // this.refreshTokenFaildedModal.hide();
           // this.common.Loader.hide();
            this.refreshTokenFailedtimerCount = 0;
            clearInterval(this.failedTokeninterval);
            //this.KeepWorkingButtonText = "Messages.YesKeepWorking";
            // this.common.PostData(this.common.ApiUrls.SystemUser.RevokeToken, null, false, lastToken).then(function (data) {
            // });
          }
          else {
            //this.KeepWorkingButtonText = "Messages.YesKeepWorking";
            this.common.RemoveLocalStorage("refreshTokenInProgress");
          }

        } catch (e) {
         // this.KeepWorkingButtonText = "Messages.YesKeepWorking";
          this.common.RemoveLocalStorage("refreshTokenInProgress");
        }
      }, error => {
        //this.KeepWorkingButtonText = "Messages.YesKeepWorking";
        this.common.RemoveLocalStorage("refreshTokenInProgress");
      });
    }
  }
  startRefreshTokenFailedTimer() {
    this.failedTokeninterval = setInterval(() => {
      if (this.refreshTokenFailedtimerCount > 0) {
        this.refreshTokenFailedtimerCount--;
        if (this.refreshTokenFailedtimerCount <= 0) {
          this.common.RedirectToLogin();
        }
      }
    }, 1000)
  }
}
